// extracted by mini-css-extract-plugin
export default {"root":"SelectProducts_root__LPF+r","productsContainer":"SelectProducts_productsContainer__RGaVg","product":"SelectProducts_product__qUHU+","isAdded":"SelectProducts_isAdded__nVohX"};